export enum ProjectTimeReportSourceEnum {
  PROJECT = 'PROJECT',
  HELPDESK = 'HELPDESK',
  DEAL = 'DEAL',
}
